/**
 * Firestore disjunction limits: `in`, `not-in`, and `array-contains-any` each allow at most this
 * many values per query clause.
 * @see https://firebase.google.com/docs/firestore/query-data/queries#in_and_array-contains-any
 */
export const FIRESTORE_IN_QUERY_MAX_VALUES = 30;

/**
 * Split an array into fixed-size chunks (e.g. for batched `where('field', 'in', chunk)` or
 * `array-contains-any` calls).
 *
 * @template T
 * @param {T[]} arr
 * @param {number} [chunkSize=FIRESTORE_IN_QUERY_MAX_VALUES]
 * @returns {T[][]}
 */
export function splitArrayIntoChunks(arr, chunkSize = FIRESTORE_IN_QUERY_MAX_VALUES) {
  const size = chunkSize > 0 ? chunkSize : FIRESTORE_IN_QUERY_MAX_VALUES;
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}
